import React, { useState } from 'react';
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    Link,
    MenuItem,
    SelectChangeEvent,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { CollectionItemsViewSelector } from './CollectionItemsViewSelector';
import SelectStyled from '../../shared/SelectStyled';
import { COLLECTION_SORT_KEYS } from '../../../utils/constans/collectionSortKeys';
import { useTranslation } from 'react-i18next';
import CollectionFilterDrawer from '../CollectionFilter/CollectionFilterDrawer';
import useMobileMenu from 'hooks/useMobileMenu';
import FlexBox from 'components/shared/FlexBox';

export const CollectionActionWrapper: React.FC<ActionsProps> = (props) => {
    const {
        selectedLayout,
        handleSelectLayout,
        handleSortSelect,
        sort,
        collectionIds,
        search,
    } = props;
    const { t } = useTranslation('collection');
    const theme = useTheme();
    const isLgBreakpoint = useMediaQuery(theme.breakpoints.down('lg'));
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const mobileMenu = useMobileMenu();

    const handleChange = (event: SelectChangeEvent) => {
        handleSortSelect(event.target.value as string);
    };

    return (
        <Grid container alignItems="center" sx={{ paddingBottom: '10px' }}>
            {isLgBreakpoint && (
                <Grid item xs>
                    <FlexBox flexDirection="row" alignItems={'center'} gap={5}>
                        <img
                            style={{ width: '15px', height: '15px' }}
                            src="/assets/icons/filter.svg"
                        ></img>
                        <Box
                            onClick={() =>
                                mobileMenu.showCollectionFilter(true)
                            }
                        >
                            {t('COLLECTIONS.FILTER')}
                        </Box>
                    </FlexBox>
                </Grid>
            )}
            {!isMobile && (
                <Grid item xs>
                    <>
                        <CollectionItemsViewSelector
                            handleSelectLayout={handleSelectLayout}
                            selectedLayout={selectedLayout}
                        />
                    </>
                </Grid>
            )}
            <Grid item xs>
                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <FormControl variant="filled">
                        <InputLabel
                            sx={{
                                color: '#999999',
                            }}
                        >
                            {t('COLLECTIONS.SORT_LABEL')}
                        </InputLabel>
                        <SelectStyled
                            label={t('COLLECTIONS.SORT_LABEL').toString()}
                            value={sort}
                            onChange={handleChange}
                        >
                            {COLLECTION_SORT_KEYS.map((sortItem) => (
                                <MenuItem key={sortItem} value={sortItem}>
                                    {t('COLLECTIONS.SORTS.' + sortItem)}
                                </MenuItem>
                            ))}
                        </SelectStyled>
                    </FormControl>
                </Box>
            </Grid>
            <CollectionFilterDrawer
                collectionId={
                    collectionIds.length > 0 ? collectionIds[0] : null
                }
                search={search}
            ></CollectionFilterDrawer>
        </Grid>
    );
};

type ActionsProps = {
    collectionIds: number[];
    selectedLayout: string;
    sort: string;
    search: string;
    handleSelectLayout: (id: string) => void;
    handleSortSelect: (sort) => void;
};
